import type { Machine } from '@bridgewerk/shared';
import { LiveMetricsCard } from '../components/LiveMetricsCard.js';
import { StatusTimeline } from '../components/StatusTimeline.js';
import { MachineInfoCard } from '../components/MachineInfoCard.js';
import { ConnectionStatusCard } from '../components/ConnectionStatusCard.js';
import { WerkOsInsightCard } from '../components/WerkOsInsightCard.js';
import { useMachineTelemetry } from '../hooks/useMachineTelemetry.js';
import { rangeToBounds } from '../components/DateRangePicker.js';

export interface OverviewTabProps {
  readonly shopId: string | null;
  readonly machine: Machine;
}

export function OverviewTab({ shopId, machine }: OverviewTabProps): JSX.Element {
  const range = rangeToBounds('24h');
  const { points, isLoading } = useMachineTelemetry({
    shopId,
    machineId: machine.machine_id,
    range,
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-4">
      <div className="space-y-4">
        <LiveMetricsCard machine={machine} />
        <StatusTimeline points={points} loading={isLoading} />
      </div>
      <div className="space-y-4">
        <MachineInfoCard machine={machine} />
        <ConnectionStatusCard />
        <WerkOsInsightCard machine={machine} />
      </div>
    </div>
  );
}
